// @flow
import { SET_HEADER_VISIBLITY } from '../constants/action_types'

export type HeaderType = {
    visible: boolean,
}

type HeaderActionType = {
    ...HeaderType,
    type: string,
}

const initialState = {
    visible: true,
}

export default function error(state: HeaderType = initialState, action: HeaderActionType) {
    let ret = state
    if (action.type === SET_HEADER_VISIBLITY) {
        ret = {
            ...state,
            visible: action.visible,
        }
    }
    return ret
}
